module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    class: _vm.classes
  }, [(_vm.$store.getters['config/isManabi']) ? [(_vm.id === 'seiseki') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-down is-white"
  })]), _vm._v(" "), _c('dn-expand-transition', [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "dn-gnavi__category-body"
  }, [_vm._l((_vm.computedGroups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-gnavi__link dn-gnavi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-gnavi__link",
        class: {
          'dn-gnavi__link--auth': link.auth,
            'dn-gnavi__link--matched': link.matched,
            'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('i', {
        staticClass: "dn-gnavi__link__bg"
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-gnavi__text",
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)])] : (_vm.id === 'TOP' || _vm.id === 'myuniv_bible' || _vm.id === 'exam_bible' || _vm.id === 'self_check') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])] : (_vm.id === 'manabi' || 'dn') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])] : _vm._e()] : [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-right is-white"
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-up is-white"
  })]), _vm._v(" "), _c('dn-expand-transition', [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "dn-gnavi__category-body"
  }, [_vm._l((_vm.computedGroups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-gnavi__link dn-gnavi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-gnavi__link",
        class: {
          'dn-gnavi__link--auth': link.auth,
            'dn-gnavi__link--matched': link.matched,
            'dn-gnavi__link--current': link.current,
            'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('i', {
        staticClass: "dn-gnavi__link__bg"
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-gnavi__text",
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7881826","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/navigations/Gnavi/GnaviCategory.vue
// module id = 363
// module chunks = 1